import { Component } from '@angular/core';
import { FacebookAccount } from './facebook-account.model';
import { RouterConst } from '../../../../globals/RoutersConst';
import { BreadcrumbService } from '../../../../breadcrumb.service';

import { ClientsService } from '../../../../services/clients/clients.service';
import { Globals } from '../../../../globals/Globals';
import { SuperClass } from '../../../../superclass/SuperClass';
import { WsService } from '../../../../services/websocket/WsService';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-analytics-facebook-accounts',
  templateUrl: './facebook-accounts.component.html',
  styleUrls: ['./facebook-accounts.component.css'],
})
export class AnalyticsFacebookAccountsComponent extends SuperClass {
  accounts: FacebookAccount[];

  selectedRow: FacebookAccount;
  newAccount: FacebookAccount;
  newAccountForm: FormGroup;
  selectedRowForm: FormGroup;

  display = false;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Accounts' },
      {
        label: 'Facebook Accounts',
        routerLink: [
          { outlets: { sub: [RouterConst.ANALYTICS_FACEBOOK_ACCOUNTS] } },
        ],
      },
    ]);
    this.newAccount = new FacebookAccount();
  }

  reloadData() {
    this.http_getAllAccounts('facebook', (data: any) => {
      if (data.result === Globals.RESPONSE_RESULT_SUCCESS) {
        this.accounts = data.payload;
      }
    });

    this.selectedRowForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });

    this.newAccountForm = this.fb.group({
      name: new FormControl('', Validators.required),
      appId: new FormControl('', Validators.required),
      secret: new FormControl('', Validators.required),
    });
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  selectRow(e) {
    this.selectedRow = new FacebookAccount(e.data);
  }

  saveAccount() {
    this.http_updateAccounts(this.selectedRow, 'facebook', (data: any) => {
      this.showSuccessMessage('Account has been updated');
      this.unselectRow();
      this.accounts = data.payload;
    });
  }

  addNewAccount() {
    this.display = true;
    this.newAccount = new FacebookAccount();
  }

  createNewAccount() {
    this.http_addAccount(this.newAccount, 'facebook', (data: any) => {
      this.showSuccessMessage('Account has been created');
      this.unselectRow();
      this.accounts = data.payload;
    });
    this.display = false;
  }

  deleteAccount() {
    this.http_deleteAccount(
      { id: this.selectedRow.id },
      'facebook',
      (data: any) => {
        this.showSuccessMessage('Account has been deleted');
        this.unselectRow();
        this.accounts = data.payload;
      },
    );
  }

  unselectRow() {
    this.selectedRow = undefined;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/accounts/facebook-accounts/facebook-accounts.component.ts